import './Checkbox.css';
import {useState} from "react";

const inputMainProps = ['required', 'name', 'value', 'onChange', 'placeholder'];

function Checkbox(props) {
    const [checked, setChecked] = useState(props.checked);

    const getMainProps = (elementProps) => {
        const result = {};
        Object.entries(props).forEach(([propName, value]) => {
            if (elementProps.indexOf(propName) !== -1) {
                if (propName === "value") {
                    if (value) {
                        result.checked = true;
                    }
                } else {
                    result[propName] = value
                }
            }
        });
        return result;
    }

    const handleChange = (e) => {
        setChecked(!checked);
        props.onChange(e.target.name, !checked);
    }

    return (
        <label className="form-checkbox">
            <input checked={checked} type="checkbox" {...getMainProps(inputMainProps)} onChange={handleChange}/>
            {props.label}
        </label>
    );
}

export default Checkbox;